import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Slider } from 'antd';

export function SliderControl({ name, value, children, settings, onChange, ...props }) {
  const [percent, setPercent] = useState(value);

  useEffect(() => {
    setPercent(value);
  }, [value]);

  return (
    <Slider
      {...settings}
      {...props}
      onAfterChange={value => onChange({ target: { name, value } })}
      onChange={value => setPercent(value)}
      value={typeof percent === 'number' ? percent : 0}
    />
  );
}

SliderControl.propTypes = {
  name: PropTypes.string,
  value: PropTypes.number,
  settings: PropTypes.any,
  onChange: PropTypes.func,
  children: PropTypes.node,
};
